import styled from "styled-components";

const PageLinking = styled.div`
  padding-bottom: 16px;
  font-size: 14px;
  display: block;
  line-height: 1.4;
  color: #757575;
  transition: color 0.12s ease-out 0s;
  cursor: pointer;
`;
export default PageLinking;
